import { NgStyle } from '@angular/common';
import { Component, DestroyRef, Input, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CmsItem } from '@coin/shared/cms/util';
import { V2ButtonComponent, V2TextInputComponent } from '@coin/shared/core/ui-storybook';
import { TranslateModule } from '@ngx-translate/core';
import { SelectMediaComponent } from '../../../dialogs/shared/select-media/select-media.component';
import { HtmlEditorComponent } from '../../shared/html-editor/html-editor.component';

@Component({
  selector: 'coin-gmm-text-image-link',
  templateUrl: './text-image-link.component.html',
  styleUrls: ['./text-image-link.component.scss'],
  standalone: true,
  imports: [
    NgStyle,
    HtmlEditorComponent,
    V2ButtonComponent,
    MatFormFieldModule,
    TranslateModule,
    FormsModule,
    V2TextInputComponent
  ]
})
export class TextImageLinkComponent {
  private dialog = inject(MatDialog);
  private destroyRef = inject(DestroyRef);

  @Input() item: CmsItem<'text-image-link'>;
  @Input() contentEdit = false;

  public editPicture(item: TextImageLinkComponent['item']): void {
    SelectMediaComponent.openDialog(this.dialog, { url: item?.img, mediaType: 'image' })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(newImage => {
        if (newImage) {
          item.img = newImage.mediaUrl;
        }
      });
  }

  public gotoPage(link: string): void {
    window.open(link, '_blank');
  }
}
